<template>
    <Splide v-if="news.length" class="news-slider-news" :options="splideOptions">
        <SplideSlide
            v-for="i in news"
            :key="i.id">
            <NewsCard card :news="i" />
        </SplideSlide>
    </Splide>
</template>

<script setup lang="ts">
    import { Splide, SplideSlide } from '@splidejs/vue-splide';
    import NewsCard from './NewsCard.vue';

    const props = defineProps<{
        news: any[];
    }>();

    const splideOptions = ref({
        type: 'loop',
        perPage: 5,
        perMove: 1,
        gap: '3rem',
        pagination: false,
        arrows: false,
        autoplay: props.news.length > 3,
        interval: 3000,
        rewind: true,
        breakpoints: {
            1800: {
                perPage: 4,
                gap: '2rem',
            },
            1500: {
                perPage: 3,
                gap: '2rem',
            },
            1000: {
                perPage: 2,
                gap: '1rem',
            },
            640: {
                perPage: 1,
                gap: '1rem'
            },
        },
    });
</script>

<style scoped>
    .news-slider-news {
        .splide__slide {
            padding-bottom: 2rem;
        }
    }
</style>
